export default __webpack_public_path__ + "static/media/pass-success.0032599f.svg";